var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',_vm._l((_vm.lines),function(l){return _c('text',{key:l.text,class:_vm.cssClass,attrs:{"fill":"white","x":l.x,"y":l.y,"text-anchor":"middle"}},[_vm._v(_vm._s(l.text))])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }